import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../api';

export default function AdminLogin() {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    try {
      const data = await api.adminLogin(password);
      localStorage.setItem('token', data.token);
      localStorage.setItem('role', 'admin');
      navigate('/admin');
    } catch (err) {
      setError(err.message);
    }
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <h2>Admin Login</h2>
        {error && <div className="alert alert-error">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Admin Password</label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)} required />
          </div>
          <button className="btn btn-primary" style={{ width: '100%' }} type="submit">Sign In</button>
        </form>
        <div style={{ marginTop: 16, textAlign: 'center' }}>
          <a href="/portal/login" style={{ fontSize: 12, color: '#718096' }}>Client Portal →</a>
        </div>
      </div>
    </div>
  );
}
